import { isBefore, isEqual, isValid, parse } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { plateOnlyDigits, regexCEP, regexOnlyNumbers } from '../formatters';

export function isValidZipCode(zipCode: string) {
  const sizeZipCode = 8;
  const zipCodeOnlyNumbers = zipCode.replace(regexOnlyNumbers, '');
  const isNotValid =
    zipCodeOnlyNumbers.length !== sizeZipCode ||
    zipCodeOnlyNumbers === '99999999';

  if (isNotValid) {
    return false;
  }

  return regexCEP.test(zipCode);
}

export function validateCpf(cpf: string): boolean {
  const cpfTemp = cpf.replace(/\D/g, '');

  if (cpfTemp.toString().length !== 11 || /^(\d)\1{10}$/.test(cpfTemp)) {
    return false;
  }

  let result = true;

  [9, 10].forEach((j) => {
    let soma = 0;
    let r;

    cpfTemp
      .split(/(?=)/)
      .splice(0, j)
      .forEach((e, i) => {
        soma += parseInt(e, 10) * (j + 2 - (i + 1));
      });

    r = soma % 11;
    r = r < 2 ? 0 : 11 - r;

    if (r !== parseInt(cpfTemp.substring(j, j + 1), 10)) {
      result = false;
    }
  });
  return result;
}

/**
 * Valida se é uma data valida
 *
 * @param date deve estar no padrão DD/MM/AAAA
 */
export function validateDate(date: string): boolean {
  const parsedDate = parse(date, 'P', new Date(), { locale: ptBR });

  return isValid(parsedDate);
}

/**
 * Verifica se datas são iguais
 *
 * @param date1 deve estar no padrão DD/MM/AAAA
 * @param date2 deve estar no padrão DD/MM/AAAA
 */
export function isEqualDate(date1: string, date2: string): boolean {
  const parsedDate1 = parse(date1, 'P', new Date(), { locale: ptBR });
  const parsedDate2 = parse(date2, 'P', new Date(), { locale: ptBR });

  return isEqual(parsedDate1, parsedDate2);
}

/**
 * Verifica se a data1 é antes da data2
 *
 * @param date1 deve estar no padrão DD/MM/AAAA
 * @param date2 deve estar no padrão DD/MM/AAAA
 */
export function isBeforeDate(date1: string, date2: string): boolean {
  const parsedDate1 = parse(date1, 'P', new Date(), { locale: ptBR });
  const parsedDate2 = parse(date2, 'P', new Date(), { locale: ptBR });

  return isBefore(parsedDate1, parsedDate2);
}

export function isValidplate(plate: string): boolean {
  if (plate === '') {
    return false;
  }

  const parsedPlate = plateOnlyDigits(plate);
  const regexPlate = /^[A-Z]{3}[0-9][0-9A-Z][0-9]{2}$/;

  if (!regexPlate.test(parsedPlate)) {
    return false;
  }

  return true;
}

export function isEmpty<Type>(element: Type) {
  if (
    element === '' ||
    element === undefined ||
    element === null ||
    element === 'undefined' ||
    (typeof element === 'string' &&
      (!/[^\s]/.test(element) || /^\s*$/.test(element)))
  ) {
    return true;
  }

  return false;
}
